const StarYellowSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M7.80979 2.58541C7.86966 2.40115 8.13034 2.40115 8.19021 2.58541L9.30218 6.0077C9.32896 6.09011 9.40575 6.1459 9.49239 6.1459H13.0908C13.2845 6.1459 13.3651 6.39382 13.2084 6.5077L10.2972 8.62279C10.2271 8.67372 10.1978 8.764 10.2245 8.8464L11.3365 12.2687C11.3964 12.453 11.1855 12.6062 11.0287 12.4923L8.11756 10.3772C8.04746 10.3263 7.95254 10.3263 7.88244 10.3772L4.97127 12.4923C4.81453 12.6062 4.60363 12.453 4.6635 12.2687L5.77547 8.8464C5.80224 8.764 5.77291 8.67372 5.70282 8.62279L2.79164 6.5077C2.6349 6.39382 2.71545 6.1459 2.9092 6.1459H6.50761C6.59425 6.1459 6.67104 6.09011 6.69782 6.0077L7.80979 2.58541Z"
        fill="#FFBD23"
      />
    </svg>
  );
};

export default StarYellowSvg;
